import React, { useState, useEffect } from 'react';
import Contact from '../../components/contact';
import Coverage from '../../components/coverage';
import Services from 'components/services';
import ScrollContainer from '../../components/scroll-container';
import Menu from '../../components/menu';
import HomeTitle from '../../components/home-title';
import './style.scss';
import Testimoni from '../../components/testimoni';
import HiaceCommuter from '../../components/hiace-commuter';
import HiacePremio from '../../components/hiace-premio';

const HomePage: React.FC = () => {
	const [isFirstSection, setIsFirstSection] = useState(true);

	useEffect(() => {
		const handleScroll = () => {
			const container = document.querySelector('.scroll-container');
			const currentScroll = container?.scrollTop || 0;

			setIsFirstSection(currentScroll < window.innerHeight / 2);
		};

		const container = document.querySelector('.scroll-container');
		container?.addEventListener('scroll', handleScroll);
		return () => container?.removeEventListener('scroll', handleScroll);
	}, []);

	const scrollToNextSection = (e: React.MouseEvent<HTMLDivElement>) => {
		e.preventDefault();
		const container = document.querySelector('.scroll-container');
		const currentScrollTop = container?.scrollTop || 0;

		container?.scrollTo({
			top: currentScrollTop + window.innerHeight,
			behavior: 'smooth'
		});
	};

	const scrollToNextWithArrow = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();
		const container = document.querySelector('.scroll-container');
		container?.scrollTo({
			top: window.innerHeight,
			behavior: 'smooth'
		});
	};

	return (
		<>
			<Menu />
			<ScrollContainer>
				<div className="section__content section__content--title">
					<HomeTitle scrollToNextSection={scrollToNextSection} />
				</div>

				<div className="section__content section__content--services">
					<Services />
				</div>

				<div className="section__content section__content--coverage">
					<Coverage />
				</div>

				<div className="section__content section__content--testimoni">
					<Testimoni />
				</div>

				<div className="section__content section__content--fleet">
					<HiaceCommuter />
				</div>

				<div className="section__content section__content--fleet-premio">
					<HiacePremio />
				</div>

				<div className="section__content section__content--contact">
					<Contact />
				</div>

				{isFirstSection && (
					<button
						className="scroll-arrow"
						onClick={scrollToNextWithArrow}
						aria-label="Scroll to next section"
					>
						<span className="arrow-icon" />
					</button>
				)}
			</ScrollContainer>
		</>
	);
};

export default HomePage;
